import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface VehicleSpec {
  label: string;
  value: string;
}

export interface VehicleOption {
  id: string;
  name: string;
  subtitle: string;
  vehicle_type: string;
  image_url: string | null;
  label: string; // combined display name
  specs: VehicleSpec[];
  tags: string[];
}

export const useVehicleList = () => {
  const [vehicles, setVehicles] = useState<VehicleOption[]>([]);

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from("vehicles")
        .select("id, name, subtitle, vehicle_type, image_url, specs, tags")
        .eq("is_active", true)
        .order("display_order");

      if (data) {
        setVehicles(
          data.map((v: any) => ({
            id: v.id,
            name: v.name,
            subtitle: v.subtitle,
            vehicle_type: v.vehicle_type,
            image_url: v.image_url,
            label: `${v.name} — ${v.subtitle}`,
            specs: (v.specs || []) as VehicleSpec[],
            tags: (v.tags || []) as string[],
          }))
        );
      }
    };
    load();
  }, []);

  return vehicles;
};
